import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SUGGESTION_CHIP_DEFS, SuggestionChipIcon as ChipIconKey } from '../../ai-counselor.model';

/** Maps every known suggestion label (both the student and tutor/counsellor wording) to its
 *  icon; unrecognized chips render with no icon. */
const CHIP_ICON_BY_LABEL: Record<string, ChipIconKey> = SUGGESTION_CHIP_DEFS.reduce(
  (map, chip) => ({ ...map, [chip.student]: chip.icon, [chip.tutor]: chip.icon }),
  {} as Record<string, ChipIconKey>
);

@Component({
  selector: 'mindbase-suggestion-chips',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './suggestion-chips.component.html',
  styleUrl: './suggestion-chips.component.scss'
})
export class SuggestionChipsComponent {
  @Input() chips: string[] = [];
  @Output() chipSelected = new EventEmitter<string>();

  protected iconFor(chip: string): ChipIconKey | null {
    return CHIP_ICON_BY_LABEL[chip] ?? null;
  }
}
